<template>
  <div v-if="currentAd && isLoggedIn" class="ad-slot">
    <div class="ad-content">
      <button class="close-button" @click="dismissAd">×</button>
      <a :href="currentAd.link" target="_blank" @click="trackAdClick">
        <img :src="sizedAdImage(currentAd.image)" class="ad-image" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ProfileActions } from '@/store/modules/user/profile/types';
import { RootActions, EventTypes } from '@/store/types';
import imageSizeMixin from '@/components/mixins/image-size';

export default imageSizeMixin.extend({
  name: 'AdSlot',
  computed: {
    ...mapState('user/profile', ['currentProfile', 'currentAd']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('user/profile', ['isLoaded'])
  },
  methods: {
    ...mapActions('user/profile', {
      enableChatbot: ProfileActions.ENABLE_CHATBOT,
      fetchAds: ProfileActions.FETCH_ADS,
      dismissAd: ProfileActions.DISMISS_AD
    }),
    ...mapActions([RootActions.DISPATCH_EVENT]),
    trackAdClick() {
      this[RootActions.DISPATCH_EVENT]({
        type: EventTypes.AD_CLICK,
        eventObj: { ad_url: this.currentAd.link }
      });
    }
  },
  watch: {
    isLoaded: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fetchAds();
        }
      }
    },
  },
  mounted() {
    if (this.isLoaded) {
      this.fetchAds();
    }
  }
});
</script> 